
import React from "react";
import { Link } from "react-router-dom";
import SwapRequestLayout from "./SwapRequestLayout";

const SwapRequestNotFound: React.FC = () => {
  return (
    <SwapRequestLayout>
      <div className="max-w-3xl mx-auto text-center py-12">
        <h2 className="text-2xl font-bold mb-4">Swap Request Not Found</h2>
        <p className="mb-6">The swap request you're looking for doesn't exist or you don't have permission to view it.</p>
        <Link to="/reagents" className="text-reagent-blue hover:underline">
          Browse available reagents
        </Link>
      </div>
    </SwapRequestLayout>
  );
};

export default SwapRequestNotFound;
